<div class="sb-header-with-counter background-color-regular" [ngClass]="{ 'pr-0': haveCount }">
  <sb-sport-icon [sport]="sport?.SportHandle"></sb-sport-icon>
  <h2 *ngIf="!text && !sport" class="sb-header-with-counter--title color-dark">{{ "nowLive" | translate }}</h2>
  <h2 *ngIf="!text && sport?.Name" class="sb-header-with-counter--title color-dark">
    {{ sport?.Name | sportsTitleCase }}
  </h2>
  <h2 *ngIf="text" class="sb-header-with-counter--title color-dark">{{ text }}</h2>
  <sb-counter *ngIf="haveCount" [count]="count" (click)="onClick.emit()"></sb-counter>
</div>
